module.exports = __webpack_public_path__ + "img/1917.f760cfd8.gif";